import api from 'utils/api';

export const fetchUsersApi = () =>
  api.get('/find/users');

export const deactivateUserApi = (userId) =>
  api.put('/admin/deactivate-user', { userId });

export const reactivateUserApi = (userId) =>
  api.put('/admin/reactivate-user', { userId });
